import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { Checkbox } from "antd";

import classNames from "classnames";
import Spacer from "components/Spacer";
import FileIcon from "../../../../../FileIcon";
import { getExtName } from "../../../../../../../../../Utils/filter";

interface AsideLinkProps {
    filename: string;
    fileType: string;
    desc?: string;
    active?: boolean;
    onClick: () => void;
    finished?: boolean;
}

export default function AsideLink({
    filename,
    fileType,
    desc,
    active,
    onClick,
    finished
}: AsideLinkProps) {
    const extName = useMemo(() => getExtName(filename), [filename]);

    const title = useMemo(
        () => filename.substring(0, filename.length - extName.length),
        [extName, filename]
    );

    return (
        <div
            title={filename}
            className={classNames(styles.root, { [styles.active]: active })}
            onClick={onClick}>
            <div className={styles.main}>
                <div className={classNames(styles.icon)}>
                    <FileIcon ext={fileType} />
                </div>

                <div className={styles.title}>{title}</div>

                {extName && <div className={styles.ext}>{extName}</div>}

                <Spacer />

                <Checkbox className={styles.check} checked={finished} />
            </div>

            {desc && <div className={styles.desc}>{desc}</div>}
        </div>
    );
}
